/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of GameTimeFootage Inc.
 #*
 #* Copyright NextPro 2018. All Rights Reserved.
 #*
 #*===================================================================
 */

// tslint:disable:max-classes-per-file
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { EffectsModule } from '@ngrx/effects';
import { ErrorHandler, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { MetaReducer, StoreModule } from '@ngrx/store';
import { BrowserModule } from '@angular/platform-browser';
import { TranslateModule } from '@ngx-translate/core';
import { SocketIoConfig, SocketIoModule } from 'ngx-socket-io';

import { ReactiveFormsModule } from '@angular/forms';
import { ToastNoAnimationModule } from 'ngx-toastr';
import { DragulaModule } from 'ng2-dragula';

import { environment } from 'environments/environment';

import { AppComponent } from 'app/app.component';
import { AppRoutes } from 'app/app.routing';
import { LoadingBarInterceptor } from 'app/shared/interceptors/loading-bar.interceptor';
import { SharedModule } from 'app/shared/shared.module';
import { TokenInterceptor } from 'app/shared/interceptors/app.token.interceptor';
import { ErrorHandlerService } from 'app/shared/services/error-handler.service';
import { modalComponents } from 'app/shared/modals';
import { clearState } from 'app/store/reducers/reset-store.reducer';

export const metaReducers: MetaReducer<any>[] = [clearState];

const config: SocketIoConfig = {
  url: environment.apiHostname,
  options: { transports: ['websocket'], upgrade: false },
};

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserAnimationsModule,
    BrowserModule,
    DragulaModule.forRoot(),
    EffectsModule.forRoot([]),
    HttpClientModule,
    ReactiveFormsModule,
    RouterModule.forRoot(AppRoutes, {
    // enableTracing: true,
    scrollPositionRestoration: 'enabled',
    onSameUrlNavigation: 'reload',
    relativeLinkResolution: 'legacy'
}),
    SharedModule.forRoot(),
    StoreModule.forRoot(
      {},
      {
        metaReducers,
        runtimeChecks: {
          strictActionImmutability: environment.development,
          strictActionSerializability: environment.development,
          strictStateImmutability: environment.development,
          strictStateSerializability: environment.development,
        },
      }
    ),
    TranslateModule.forRoot(),
    ToastNoAnimationModule.forRoot({
      timeOut: 3000,
      positionClass: 'toast-bottom-left',
      preventDuplicates: true,
      easeTime: 1500,
    }),
    SocketIoModule.forRoot(config),

    environment.imports,
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoadingBarInterceptor,
      multi: true,
    },
    { provide: ErrorHandler, useClass: ErrorHandlerService },
  ],
  bootstrap: [AppComponent],
  entryComponents: [...modalComponents],
})
export class AppModule {}
